jQuery($ => {
  class Select {
      constructor(element) {
          this._        = element;
          this._element = $(element);

          this._button  = this._element.find('.us-a-select__button');
          this._list    = this._element.find('.us-a-select__list');
          this._options = this._element.find('.us-a-select__item');
          this._native  = this._element.find('.us-a-select__native');

          this._buttonText = this._element.find('.us-a-select__value');
          this._ariaLabel  = this._button.attr('data-label');

          this._selectedItem  = this._list.find('.us-a-select__item--selected');
          this._selectedLabel = this._selectedItem ? this._selectedItem.textContent: null;
          this._selectedValue = this._selectedItem ? this._selectedItem.val():       null;

          this._reset = this._element.find('.us-a-select__reset');

          this._details = {
              selected: {
                  label: this._selectedLabel,
                  value: this._selectedValue
              }
          }

          this.init();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      init() {
          this.setupHandlers();
          this._element.trigger('init', this._details);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupHandlers() {
          this._button.on('mousedown', this.handleButtonMousedown);
          this._button.on('keydown', this.handleButtonKeydown);

          this._reset.on('mousedown', this.handleReset);

          this._options.each((_, option) => {
              $(option).on('mousedown', event => {
                  this.handleOptionMousedown(event, option);
              });

              $(option).on('keydown', event => {
                  this.handleOptionKeydown(event, option);
              });

              $(option).on('blur', event => {
                  this.handleOptionBlur(event, option);
              });
          });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reset
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReset = () => {
        this._element.trigger('reset');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle List Open
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleListOpen = () => {
          this._element.addClass('us-a-select--open');
          this._list.show();

          if (this._selected) {
              this._selected.focus();
          } else {
              this._options[0].focus();
          }

          this._element.trigger('openList', {
              details: this._details
          });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle List Close
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleListClose = () => {
          this._element.removeClass('us-a-select--open');
          this._list.hide();

          this._button.focus();

          this._element.trigger('closeList', {
              details: this._details
          });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle List Toggle
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleListToggle = () => {
          const isVisible = this._list[0].offsetWidth > 0 && this._list[0].offsetHeight > 0;

          if (isVisible) {
              this.handleListClose();
          } else {
              this.handleListOpen();
          }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Select
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionSelect = option => {
          this._options.each(function () {
              $(this).removeClass('us-a-select__item--selected');
              $(this).attr('arius-a-selected', 'false');
          });

          $(option).addClass('us-a-select__item--selected');
          $(option).attr('arius-a-selected', 'true');

          this._selected      = $(option);
          this._selectedLabel = option.textContent;
          this._selectedValue = option.dataset.value;

          this._buttonText.text(this._selectedLabel);
          this.handleAriaLabel();
          this._element.removeClass('us-a-select--unset');
          this._native.value = this._selectedValue;

          this.handleSelected(this._selectedValue);

          this.handleDetails();

          this.handleListClose();

          this._element.trigger('chooseOption', {
              details: this._details
          });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Clear
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleClear = () => {
          const placeholder = this._button.data('placeholder');

          if (placeholder) {
              this._element.addClass('us-a-select--unset');
              this._native.value = '';
              this._selectedLabel = null;
              this._selectedValue = null;

              this.handleDetails();

              this._options.each(function () {
                  $(this).removeClass('us-a-select__item--selected');
                  $(this).attr('arius-a-selected', 'false');
              });

              this._buttonText.text(placeholder);

              this._button.attr('aria-label', this._ariaLabel);
              this._button.blur();
              this._button.focus();

              this._element.trigger('clear', {
                  details: this._details
              });
          }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle List Search
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleListSearch = query => {
          const queryText = query.trim().toLowerCase();

          const results = Array.from(this._options).filter(option => {
              const text = option.textContent.trim().toLowerCase();
              return text.indexOf(queryText) === 0;
          });

          return results[0];
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Aria Label
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleAriaLabel = () => {
          const label    = this._ariaLabel;
          const value    = this._selectedLabel;
          const position = Array.from(this._options).indexOf(this._selected) + 1;
          const count    = this._options.length;

          const ariaLabel = `${label}, ${value} Selected, ${position} of ${count}`;

          this._button.attr('aria-label', ariaLabel);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Details
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleDetails = () => {
          this._details = {
              selected: {
                  label: this._selectedLabel,
                  value: this._selectedValue
              }
          }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ HandleSelected
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSelected = (value) => {
          this._native.children().filter(function () {
              return $(this).attr('value') == value;
          }).attr('selected', true);

          this._native.trigger('change');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Check If Cannot Toggle
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      cannotToggle = () => {
          return (
            this._element.hasClass('us-a-select--readonly') ||
            this._element.hasClass('us-a-select--disabled')
        );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Button Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleButtonMousedown = event => {
          event.preventDefault();
          
          if (this.cannotToggle()) return;
          
          this.handleListToggle();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Button Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleButtonKeydown = event => {
          if (this.cannotToggle()) return;
          
          switch (event.key) {
              case "Enter":
              case "spacebar":
              case " ":
              case "ArrowDown":
              case "ArrowUp":
                  event.preventDefault();
                  this.handleListOpen();
                  break;

              case "Escape":
              case "Esc":
              case "Delete":
              case "Backspace":
                  event.preventDefault();

                  this.handleClear();
                  break;

              default:
                  this._searchQuery += event.key;

                  const foundOption = this.handleListSearch(this._searchQuery);

                  if (foundOption) this.handleOptionSelect(foundOption);

                  if (this._searchTimeout) clearTimeout(this._searchTimeout);

                  this._searchTimeout = setTimeout(() => {
                      this._searchQuery = '';
                  }, 1000);
          }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Mousedown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionMousedown = (event, option) => {
          event.preventDefault();
          this.handleOptionSelect(option);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionKeydown = (event, option) => {
          event.preventDefault();

          switch (event.key) {
              case "Enter":
              case "spacebar":
              case " ":
                  this.handleOptionSelect(option);
                  break;

              case "Escape":
              case "Esc":
              case "Tab":
              case "Delete":
              case "Backspace":
                  this.handleListClose();
                  break;

              case "ArrowUp":
                  var prevItem = event.target.previousElementSibling;
                  if (prevItem) prevItem.focus();
                  break;

              case "ArrowDown":
                  var nextItem = event.target.nextElementSibling;
                  if (nextItem) nextItem.focus();
                  break;

              case "Home":
                  this._options[0].focus();
                  break;

              case "End":
                  this._options[this._options.length - 1].focus();
                  break;

              default:
                  this._searchQuery += event.key;

                  const foundOption = this.handleListSearch(this._searchQuery);

                  if (foundOption) foundOption.focus();

                  if (this._searchTimeout) clearTimeout(this._searchTimeout);

                  this._searchTimeout = setTimeout(() => {
                      this._searchQuery = '';
                  }, 1000);
          }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Option Blur
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOptionBlur = event => {
          const newTarget = event.relatedTarget;

          if (
              newTarget === null ||
              !newTarget.classList.contains('us-a-select__item') ||
              event.target.offsetParent != newTarget.parentElement
          ) {
              this.handleListClose();
          }
      }

  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.select = function () {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
          if (typeof opt == 'object' || typeof opt == 'undefined')
              _[i].select = new Select(_[i], opt);
          else
              ret = _[i].select[opt].apply(_[i].select, args);
          if (typeof ret != 'undefined') return ret;
      }
      return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.us-a-select').select();
});
